import { useEffect, useRef } from "react";
import videojs from "video.js";

import { getLibraryAsset } from "@edclub/lib";

import "video.js/dist/video-js.css";
import "./App.css";

const watchTracker = new Array(100).fill(0);

//(todo): we have to store caption selection & volume level in storage

const App = () => {
  const videoNodeRef = useRef(null);
  const playerRef = useRef(null);
  const videoData = getLibraryAsset(approuter.lesson.activity.video_id);

  const { lesson } = approuter;

  // Handle missing video data
  if (!videoData) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100vw",
          height: "100vh",
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          gap: "20px",
          fontFamily: "sans-serif",
        }}
      >
        <div
          style={{
            fontSize: "28px",
            textAlign: "center",
            padding: "0 20px",
          }}
        >
          This video is temporarily unavailable. <br />
          Please skip to continue with your lesson.
        </div>
        <button
          className="skip-button"
          style={{ position: "static", transform: "none" }}
          onClick={() => {
            approuter.finish(
              {
                performance: 100,
                attemptAttributes: {
                  did_video_skip: true,
                },
              },
              false,
            );
          }}
        >
          Skip
        </button>
      </div>
    );
  }

  const { sources: videoSources } = videoData;

  useEffect(() => {
    if (!videoNodeRef.current) return;

    const player = videojs(videoNodeRef.current, {
      autoplay: lesson.auto_start,
      controls: true,
      sources: videoSources,
      muted: lesson.start_muted,
      fluid: true,
      preload: "auto",
      controlBar: {
        fullscreenToggle: false,
        pictureInPictureToggle: false,
      },
      userActions: {
        doubleClick: false,
      },
    });

    player.play().catch((error) => {
      console.debug("Autoplay prevented:", error.name);
    });

    // track how much of the video is watched
    player.on("timeupdate", () => {
      const curTime = player.currentTime();
      const duration = player.duration();
      if (!curTime || !duration) return;
      watchTracker[Math.floor((curTime / duration) * 100)] = 1;
    });

    player.on("ended", () => {
      const percentageWatched = watchTracker.filter((v) => v).length;
      approuter.finish(
        { performance: Math.min(Math.max(percentageWatched, 1), 100) },
        false,
      );
    });

    approuter.events.on1("destroy", () => {
      player.pause();
      player.dispose();
      playerRef.current.dispose();
      playerRef.current = null;
    });

    playerRef.current = player;
  }, [videoSources]);

  return (
    <div
      style={{
        display: "flex",
        width: "100vw",
        height: "100vh",
        alignItems: "center",
      }}
    >
      {lesson.activity.can_skip && (
        <button
          className="skip-button"
          onClick={() => {
            // stop video playing after skip being triggered
            playerRef.current?.pause();

            approuter.finish(
              {
                performance: 100,
                attemptAttributes: {
                  did_video_skip: true,
                },
              },
              false,
            );
          }}
        >
          Skip
        </button>
      )}
      <div data-vjs-player={true} style={{ width: "100%", height: "100%" }}>
        <video
          ref={videoNodeRef}
          className="video-js vjs-big-play-centered"
          playsInline
        ></video>
      </div>
    </div>
  );
};

export default App;
